module.exports = " <navbar></navbar> <section class=\"page-content searchDetail\"> <search :placeholder=placeholder choose=图片></search> <div class=loading> <p class=loadingSearch><i class=\"fa fa-repeat fa-3x\" aria-hidden=true></i></p> <p>搜索中。。。。。</p> </div> <photo-list :imgs=imgs> </photo-list></section> <section class=search-more v-show=searchMore> <a v-on:click=more><i class=\"fa fa-spinner\" aria-hidden=true></i>点击加载更多...</a> </section> <foot></foot> <top></top> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/views/SearchDetail.vue
 ** module id = 85
 ** module chunks = 0
 **/